// src/api/menuApi.js
import { api_path } from "../shared.js";

// ปรับ path ให้ตรงกับ PHP backend จริง
const BASE = `${api_path}/menu/menu.php`;

async function request(method, params, body) {
  const url = params
    ? `${BASE}?${new URLSearchParams(params)}`
    : BASE;

  const res  = await fetch(url, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  const json = await res.json();
  if (!json.success) throw new Error(json.message ?? "API error");
  return json.data;
}

export const menuApi = {
  getAll: ()              => request("GET"),
  getOne: (id)            => request("GET",    { id }),
  create: (payload)       => request("POST",   null,   payload),
  update: (id, payload)   => request("PUT",    { id }, payload),
  delete: (id)            => request("DELETE", { id }),
};
